import { BiUpArrowAlt } from 'react-icons/bi';
import { GrFormView } from 'react-icons/gr';
import { formatCurrency } from '../../../utils/CurrencyUtils';

const TableCheckbox = ({ checked, onChange }) => (
    <input
        type="checkbox"
        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
        checked={checked}
        onChange={onChange}
    />
);

export default function ProductList({
    data,
    selectedItems,
    onSelectAll,
    onSelectItem,
    onSortChange,
    sortField,
    sortDirection, // ✅ new prop
    onOpenDetails
}) {

    const isAllSelected =
        data.length > 0 && selectedItems.length === data.length;

    // 🔹 Reusable sort renderer (keeps visuals identical)
    const renderSortableHeader = (label, field) => (
        <button
            onClick={() => onSortChange(field)}
            className="w-full flex justify-center items-center"
        >
            {sortField === field ? (
                <>
                    {label}
                    <BiUpArrowAlt
                        className={`mx-2 scale-150 transition-transform ${
                            sortDirection === 'desc' ? 'rotate-180' : ''
                        }`}
                    />
                </>
            ) : (
                label
            )}
        </button>
    );

    return (
        <div className="overflow-x-auto rounded-lg shadow-md border border-slate-200">
            <table className="table-fixed w-full border-collapse divide-y divide-custom_blue bg-white">
                <thead>
                    <tr className="bg-custom_blue text-white sm:text-xs lg:text-sm h-10 font-montserrat">

                        <th className="w-10 px-2">
                            <TableCheckbox
                                checked={isAllSelected}
                                onChange={onSelectAll}
                            />
                        </th>

                        <th className="w-24 hidden lg:table-cell">
                            SKU
                        </th>

                        <th>
                            {renderSortableHeader("Nome", "name")}
                        </th>

                        <th className="w-32 hidden lg:table-cell">
                            {renderSortableHeader("Preço", "price")}
                        </th>

                        <th className="w-28">
                            {renderSortableHeader("Disp.", "quantity")}
                        </th>

                        <th className="w-28 hidden sm:table-cell">
                            {renderSortableHeader("Reservado", "reserved_quantity")}
                        </th>

                        <th className="hidden md:table-cell w-40">
                            {renderSortableHeader("Categoria", "brand")}
                        </th>

                        <th className="w-24 hidden lg:table-cell">
                            Ativo
                        </th>

                        <th className="w-24"></th>

                    </tr>
                </thead>

                <tbody className="divide-y divide-slate-100">
                    {data.map((item) => (
                        <tr
                            key={item.product_id}
                            className={`text-center sm:text-xs lg:text-sm font-montserrat font-medium text-custom_gray_font transition-colors h-12 ${
                                selectedItems.includes(item.product_id)
                                    ? "bg-blue-50 hover:bg-blue-100"
                                    : "hover:bg-slate-50"
                            }`}
                        >

                            <td className="px-2">
                                <TableCheckbox
                                    checked={selectedItems.includes(item.product_id)}
                                    onChange={() => onSelectItem(item.product_id)}
                                />
                            </td>

                            <td className="hidden lg:table-cell">
                                {item.sku || '-'}
                            </td>

                            <td
                                className="truncate px-2"
                                title={item.name}
                            >
                                {item.name}
                            </td>

                            <td className="hidden lg:table-cell">
                                {formatCurrency(item.price)}
                            </td>

                            <td>
                                {item.quantity}
                            </td>

                            <td className="hidden sm:table-cell">
                                {item.reserved_quantity > 0 ? (
                                    <span className="px-2 py-0.5 rounded text-xs font-semibold bg-amber-100 text-amber-700 border border-amber-200">
                                        {item.reserved_quantity}
                                    </span>
                                ) : (
                                    <span className="text-gray-300">—</span>
                                )}
                            </td>

                            <td className="hidden md:table-cell truncate px-2">
                                {item?.category ?? "-"}
                            </td>

                            <td className='hidden lg:table-cell'>
                                <span
                                    className={`px-2 py-0.5 rounded text-xs text-white ${
                                        item.active
                                            ? "bg-green-500"
                                            : "bg-red-400"
                                    }`}
                                >
                                    {item.active ? "Sim" : "Não"}
                                </span>
                            </td>

                            <td>
                                <GrFormView
                                    onClick={() => onOpenDetails(item)}
                                    className="cursor-pointer text-slate-500 hover:text-blue-600 scale-200 mx-auto transition-colors"
                                />
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}